import React from 'react';
import { observer } from '../../shared/observer';
import { runBusy, isBusy } from '../../shared/busy';

class CardsView extends React.Component {
  state = { loading: true, adding: false, error: null, busy: {} };

  async componentDidMount() {
    try { await this.props.card.getCards(); this.setState({ loading: false }); }
    catch (e) { this.setState({ loading: false, error: e.message || 'Не удалось загрузить карты' }); }
  }

  add = async () => {
    if (this.state.adding) return;
    this.setState({ adding: true, error: null });
    try {
      const res = await this.props.card.addCard();
      if (res && res.redirect) {
        // Кнопку не разблокируем — ждём перехода на страницу привязки.
        window.location.href = res.redirect;
        return;
      }
      this.setState({ adding: false, error: 'Не удалось привязать карту' });
    } catch (e) {
      this.setState({ adding: false, error: e.message || 'Не удалось привязать карту' });
    }
  };

  remove = (id) => () => {
    if (isBusy(this, 'remove:' + id)) return;
    if (!window.confirm('Удалить карту?')) return;
    this.setState({ error: null });
    runBusy(this, 'remove:' + id, () => this.props.card.deleteCard(id))
      .catch((e) => this.setState({ error: e.message || 'Не удалось удалить карту' }));
  };

  render() {
    if (this.state.loading) return <p>Загрузка…</p>;
    const list = this.props.card.cards || [];
    return (
      <div>
        <h1>Карты оплаты</h1>
        {this.state.error && <div className="order-message">{this.state.error}</div>}
        {list.length === 0 && !this.state.error && (
          <p className="ng-checkout__hint">У вас нет привязанных карт.</p>
        )}
        {list.length > 0 && (
          <ul className="ng-cards">
            {list.map((c) => {
              const removing = isBusy(this, 'remove:' + c.id);
              return (
                <li key={c.id} className="ng-card">
                  <span className="ng-card__num">{c.masked_card_num || c.title}</span>
                  <button type="button" className={'btn btn--ghost btn--mini' + (removing ? ' is-busy' : '')} disabled={removing} onClick={this.remove(c.id)}>Удалить</button>
                </li>
              );
            })}
          </ul>
        )}
        <button
          type="button"
          className={'btn' + (this.state.adding ? ' is-busy' : '')}
          onClick={this.add}
          disabled={this.state.adding}
        >
          {this.state.adding ? 'Перенаправляем…' : '+ Привязать карту'}
        </button>
      </div>
    );
  }
}

export const Cards = observer(CardsView, ['cardStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/Cards.jsx